import { defineStore } from 'pinia';
import { useAuthStore } from '../../../store/shared/auth-store';
import { getAuth, signInWithCustomToken } from 'firebase/auth';
import { api } from '../../../plugins/axios';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '@/firebase';
import Conversation from '../entities/chats/conversation';

async function refreshFirebaseAuth() {
	const authStore = useAuthStore();
	const params = {
		fcm_token: authStore.fcmToken || undefined,
		firestore_token: true,
	};
	const meData = (await api.get('/user/auth/me', { params })).data.result;
	const meta = {
		fireStoreToken: meData.firestore_token,
		isZatcaLinked: meData.is_zatca_linked,
	};
	authStore.setMeta(meta);
}

export const useChatsStore = defineStore('whatsAppChatStore', {
	state: () => ({
		authLoading: false,
		profileSectionExpanded: false,
		profileAnimationShow: false,
		selectedConversation: undefined,
		currentView: 'chats-list', // chat-view, chats-list, profile;
		currentProfileSectionView: 'customer-view', // customer-view, customer-edit, template-preview
		selectedTemplate: undefined,
		selectedOrder: undefined,
		selectedOrderId: undefined,
	}),
	getters: {
		selectedConversationId(state) {
			return state.selectedConversation?.conversationId;
		},
		selectedConversationChannelType(state) {
			return state.selectedConversation?.channelType;
		},
	},
	actions: {
		async authenticateWithFirebase() {
			console.log('chatsStore.authenticateWithFirebase');
			this.authLoading = true;

			const authStore = useAuthStore();
			const fireStoreToken = authStore.meta.fireStoreToken;

			if (!fireStoreToken) {
				console.log('[WhatsApp V2] no fireStoreToken');
            console.log('[WhatsApp V2] try to refresh firestore token');
				await refreshFirebaseAuth();
			}

			try {
            console.log('[WhatsApp V2] fireStoreToken', fireStoreToken);
				console.time('[WhatsApp V2] Custom Firebase Auth');
				const auth = getAuth();
				await signInWithCustomToken(auth, fireStoreToken);
				console.timeEnd('[WhatsApp V2] Custom Firebase Auth');
			} catch (err) {
				console.error('[WhatsApp V2] error in signInWithCustomToken', err);
				console.timeEnd('[WhatsApp V2] Custom Firebase Auth');

				console.log('[WhatsApp V2] try to refresh token');
				await refreshFirebaseAuth();

				// try to refresh token
				// await authStore.fetchUser(true, true);
				const newFireStoreToken = authStore.meta.fireStoreToken;
				console.time('[WhatsApp V2] Custom Firebase Auth');
				const auth = getAuth();
            console.log('[WhatsApp V2] newFireStoreToken', newFireStoreToken);
				await signInWithCustomToken(auth, newFireStoreToken);
				console.timeEnd('[WhatsApp V2] Custom Firebase Auth');
			} finally {
				this.authLoading = false;
			}
		},
		selectConversation(conversation) {
			if (this.selectedConversation === undefined) {
				this.toggleExpandProfile();
			}
			this.selectedConversation = conversation;
			this.currentView = 'chat-view';
			this.currentProfileSectionView = 'customer-view';
		},
		closeConversation() {
			this.selectedConversation = undefined;
			this.profileSectionExpanded = false;
			this.currentView = 'chats-list';
		},
		async selectConversationById(conversationId, channelType = 'whatsapp') {
			const authStore = useAuthStore();
			const tenantId = authStore.tenantId;

			const conversationRef = doc(
				db,
				`tenants/${tenantId}/channels/${channelType}/conversations`,
				conversationId,
			);

			const conversation = await getDoc(conversationRef);
			const conversationObj = new Conversation(conversation.data());
			this.selectConversation(conversationObj);
		},
		selectTemplate(template) {
			this.selectedTemplate = template;
			if (this.profileSectionExpanded) {
				this.currentProfileSectionView = 'template-preview';
			} else {
				this.toggleExpandProfile('template-preview');
			}
		},
		closeTemplate() {
			this.selectedTemplate = undefined;
			if (!this.selectedConversation) {
				this.profileSectionExpanded = false;
				this.profileAnimationShow = false;
			}
			this.currentProfileSectionView = 'customer-view';
		},
		toggleExpandProfile(view = 'customer-view') {
			this.currentProfileSectionView = view;
			if (this.profileSectionExpanded) {
				this.profileAnimationShow = false;
				this.profileSectionExpanded = false;
			} else {
				this.profileSectionExpanded = true;
				setTimeout(() => {
					this.profileAnimationShow = true;
				}, 500);
			}
		},
		setView(view) {
			this.currentView = view;
			if (this.currentView === 'chats-list') {
				this.selectedConversation = undefined;
			}
		},
	},
});
